/* cspell:disable */
const countries = [
  {
    name: 'United States',
    abbr: 'US',
    zones: [
      'America/New_York',
      'America/Detroit',
      'America/Kentucky/Louisville',
      'America/Chicago',
      'America/Denver',
      'America/Phoenix',
      'America/Los_Angeles',
      'America/Anchorage',
      'Pacific/Honolulu',
    ],
    regions: [
      { name: 'Alabama', value: 'AL' },
      { name: 'Alaska', value: 'AK' },
      { name: 'Arizona', value: 'AZ' },
      { name: 'Arkansas', value: 'AR' },
      { name: 'California', value: 'CA' },
      { name: 'Colorado', value: 'CO' },
      { name: 'Connecticut', value: 'CT' },
      { name: 'Delaware', value: 'DE' },
      { name: 'Florida', value: 'FL' },
      { name: 'Georgia', value: 'GA' },
      { name: 'Hawaii', value: 'HI' },
      { name: 'Idaho', value: 'ID' },
      { name: 'Illinois', value: 'IL' },
      { name: 'Indiana', value: 'IN' },
      { name: 'Iowa', value: 'IA' },
      { name: 'Kansas', value: 'KS' },
      { name: 'Kentucky', value: 'KY' },
      { name: 'Louisiana', value: 'LA' },
      { name: 'Maine', value: 'ME' },
      { name: 'Maryland', value: 'MD' },
      { name: 'Massachusetts', value: 'MA' },
      { name: 'Michigan', value: 'MI' },
      { name: 'Minnesota', value: 'MN' },
      { name: 'Mississippi', value: 'MS' },
      { name: 'Missouri', value: 'MO' },
      { name: 'Montana', value: 'MT' },
      { name: 'Nebraska', value: 'NE' },
      { name: 'Nevada', value: 'NV' },
      { name: 'New Hampshire', value: 'NH' },
      { name: 'New Jersey', value: 'NJ' },
      { name: 'New Mexico', value: 'NM' },
      { name: 'New York', value: 'NY' },
      { name: 'North Carolina', value: 'NC' },
      { name: 'North Dakota', value: 'ND' },
      { name: 'Ohio', value: 'OH' },
      { name: 'Oklahoma', value: 'OK' },
      { name: 'Oregon', value: 'OR' },
      { name: 'Pennsylvania', value: 'PA' },
      { name: 'Rhode Island', value: 'RI' },
      { name: 'South Carolina', value: 'SC' },
      { name: 'South Dakota', value: 'SD' },
      { name: 'Tennessee', value: 'TN' },
      { name: 'Texas', value: 'TX' },
      { name: 'Utah', value: 'UT' },
      { name: 'Vermont', value: 'VT' },
      { name: 'Virginia', value: 'VA' },
      { name: 'Washington', value: 'WA' },
      { name: 'West Virginia', value: 'WV' },
      { name: 'Wisconsin', value: 'WI' },
      { name: 'Wyoming', value: 'WY' },
    ],
  },
  {
    name: 'Austria',
    abbr: 'AT',
    zones: ['Europe/Vienna'],
  },
  {
    name: 'Belgium',
    abbr: 'BE',
    zones: ['Europe/Brussels'],
  },
  {
    name: 'Canada',
    abbr: 'CA',
    zones: [
      'America/St_Johns',
      'America/Halifax',
      'America/Toronto',
      'America/Winnipeg',
      'America/Edmonton',
      'America/Vancouver',
    ],
    regions: [
      { name: 'Alberta', value: 'AB' },
      { name: 'British Columbia', value: 'BC' },
      { name: 'Manitoba', value: 'MB' },
      { name: 'New Brunswick', value: 'NB' },
      { name: 'Newfoundland and Labrador', value: 'NL' },
      { name: 'Northwest Territories', value: 'NT' },
      { name: 'Nova Scotia', value: 'NS' },
      { name: 'Nunavut', value: 'NU' },
      { name: 'Ontario', value: 'ON' },
      { name: 'Prince Edward Island', value: 'PE' },
      { name: 'Quebec', value: 'QC' },
      { name: 'Saskatchewan', value: 'SK' },
      { name: 'Yukon', value: 'YT' },
    ],
  },
  {
    name: 'Switzerland',
    abbr: 'CH',
    zones: ['Europe/Zurich'],
  },
  {
    name: 'China',
    abbr: 'CN',
    zones: ['Asia/Shanghai'],
  },
  {
    name: 'Czech Republic',
    abbr: 'CZ',
    zones: ['Europe/Prague'],
  },
  {
    name: 'Germany',
    abbr: 'DE',
    zones: ['Europe/Berlin'],
  },
  {
    name: 'Denmark',
    abbr: 'DK',
    zones: ['Europe/Copenhagen'],
  },
  {
    name: 'Spain',
    abbr: 'ES',
    zones: ['Europe/Madrid', 'Atlantic/Canary'],
  },
  {
    name: 'Finland',
    abbr: 'FI',
    zones: ['Europe/Helsinki'],
  },
  {
    name: 'France',
    abbr: 'FR',
    zones: ['Europe/Paris'],
  },
  {
    name: 'Britain (UK)',
    abbr: 'GB',
    zones: ['Europe/London'],
    regions: [
      { name: 'England', value: 'ENG' },
      { name: 'Scotland', value: 'SCT' },
      { name: 'Wales', value: 'WLS' },
      { name: 'Northern Ireland', value: 'NIR' },
    ],
  },
  {
    name: 'Hong Kong',
    abbr: 'HK',
    zones: ['Asia/Hong_Kong'],
  },
  {
    name: 'Indonesia',
    abbr: 'ID',
    zones: ['Asia/Jakarta', 'Asia/Makassar', 'Asia/Jayapura'],
  },
  {
    name: 'Ireland',
    abbr: 'IE',
    zones: ['Europe/Dublin'],
  },
  {
    name: 'India',
    abbr: 'IN',
    zones: ['Asia/Kolkata'],
  },
  {
    name: 'Italy',
    abbr: 'IT',
    zones: ['Europe/Rome'],
  },
  {
    name: 'Japan',
    abbr: 'JP',
    zones: ['Asia/Tokyo'],
  },
  {
    name: 'Korea (South)',
    abbr: 'KR',
    zones: ['Asia/Seoul'],
  },
  {
    name: 'Luxembourg',
    abbr: 'LU',
    zones: ['Europe/Luxembourg'],
  },
  {
    name: 'Mexico',
    abbr: 'MX',
    zones: [
      'America/Mexico_City',
      'America/Cancun',
      'America/Mazatlan',
      'America/Tijuana',
    ],
  },
  {
    name: 'Malaysia',
    abbr: 'MY',
    zones: ['Asia/Kuala_Lumpur'],
  },
  {
    name: 'Netherlands',
    abbr: 'NL',
    zones: ['Europe/Amsterdam'],
  },
  {
    name: 'Norway',
    abbr: 'NO',
    zones: ['Europe/Oslo'],
  },
  {
    name: 'Philippines',
    abbr: 'PH',
    zones: ['Asia/Manila'],
  },
  {
    name: 'Poland',
    abbr: 'PL',
    zones: ['Europe/Warsaw'],
  },
  {
    name: 'Portugal',
    abbr: 'PT',
    zones: ['Europe/Lisbon', 'Atlantic/Azores'],
  },
  {
    name: 'Sweden',
    abbr: 'SE',
    zones: ['Europe/Stockholm'],
  },
  {
    name: 'Singapore',
    abbr: 'SG',
    zones: ['Asia/Singapore'],
  },
  {
    name: 'Thailand',
    abbr: 'TH',
    zones: ['Asia/Bangkok'],
  },
  {
    name: 'Taiwan',
    abbr: 'TW',
    zones: ['Asia/Taipei'],
  },
  {
    name: 'Vietnam',
    abbr: 'VN',
    zones: ['Asia/Ho_Chi_Minh'],
  },
];

export default countries;
